import { ExtendedCheckboxTheme } from '../../base/tokens'

export const checkbox: ExtendedCheckboxTheme = {
  base: 'w-4 h-4 rounded border-cyan-500/20 bg-gray-900/50 text-cyan-400 focus:ring-cyan-400/30',
  checked: 'bg-cyan-400 border-cyan-400',
  wrapper: 'flex items-center gap-2',
  input: 'w-4 h-4 rounded border-cyan-500/20 bg-gray-900/50 text-cyan-400 focus:ring-cyan-400/30',
  label: {
    text: 'text-sm text-cyan-100/70',
    button: 'text-cyan-400 hover:text-cyan-300 transition-colors'
  },
  confirmation: {
    wrapper: 'w-full max-w-md p-6 bg-gray-800/50 rounded-lg border border-cyan-500/20',
    title: 'text-lg font-medium text-cyan-400 mb-4',
    content: {
      wrapper: 'space-y-4 mb-6',
      text: 'text-sm text-cyan-100/70',
      list: 'space-y-2 text-sm text-cyan-100/70'
    },
    buttons: {
      wrapper: 'flex gap-3',
      confirm: 'flex-1 px-4 py-2 rounded-lg bg-gradient-to-r from-cyan-500/20 to-blue-500/20 border border-cyan-500/20 hover:from-cyan-500/30 hover:to-blue-500/30 text-cyan-400 hover:text-cyan-300 transition-all duration-300',
      cancel: 'flex-1 px-4 py-2 rounded-lg border border-cyan-500/20 text-cyan-400 hover:text-cyan-300 hover:border-cyan-400/30 transition-all duration-300'
    }
  },
  _variants: {
    terms: {
      wrapper: 'flex items-center gap-2 mb-6',
      button: 'text-cyan-400 hover:text-cyan-300 transition-colors'
    },
    form: {
      wrapper: 'flex items-start gap-2',
      label: 'text-sm text-cyan-100/90'
    }
  }
} 